import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_TABLE } from '../../../../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import {
  AntimalwareOnDemandExclusionTask,
  AntimalwareOnDemandExclusionTaskType,
} from '@nirvana/shared/dtos/types/policies/common';
import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates, validatePathByType } from './utils/validators';
import { MaxLengthValidator } from '../../../../../../../../../../ui/gzForm/validators/max-length.validator';
import { MAX_TASK_PATH_LENGTH } from '../../../../../../../utils/uiSettings/antimalware/antimalware.values';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_TABLE)
export class GzAntimalwareOnDemandExclusionsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  AntimalwareOnDemandExclusionTask,
  AntimalwareOnDemandExclusionTask
> {
  protected hasReorderRowAction = false;
  private editedType: AntimalwareOnDemandExclusionTaskType;

  // bind this for access to edited row index
  protected columns = getTableColumns([
    RequiredValidator(translateFn('Required field')),
    MaxLengthValidator(
      MAX_TASK_PATH_LENGTH,
      translateFn('The path must not exceed {maxLength} characters.', {
        maxLength: MAX_TASK_PATH_LENGTH,
      })
    ),
    CustomizableValidator((value: string) => validatePathByType(this.editedType, value)),
  ]);

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-antimalware-on-demand-exclusions-item
      id="${GRID_ITEM_FORM_ID}"
      style="padding-bottom: 25px;"
    ></gz-policy-panel-antimalware-on-demand-exclusions-item>`;
  }

  protected onEditRowEnabled(event: CustomEvent) {
    super.onEditRowEnabled(event);
    this.editedType = event.detail.item.taskType;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: AntimalwareOnDemandExclusionTask): ValidationResult {
    // check for duplicates
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected validateGridItemBeforeEdit(
    oldItem: AntimalwareOnDemandExclusionTask,
    newItem: AntimalwareOnDemandExclusionTask
  ): ValidationResult {
    // skip if item is not changed
    if (newItem.path === oldItem.path) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }
}
